import { LocaleType, LOCALES } from '@benzinga/translate';
import { DomainType, DOMAINS, GlobalRegisterType } from '../entities';
import { isDomainHasIdentityConfig } from './domain';
import { getSubDomain } from '@benzinga/utils';

export const getRegisterTypeByLocale = (locale: LocaleType): GlobalRegisterType | null => {
  const REGISTER_TYPES: Partial<Record<LocaleType, GlobalRegisterType>> = {
    [LOCALES.EN]: 'american',
    [LOCALES.KO]: 'korean',
    [LOCALES.JA]: 'japanese',
    [LOCALES.ES]: 'spanish',
    [LOCALES.FR]: 'french',
    [LOCALES.IT]: 'italian',
  };

  return REGISTER_TYPES[locale] || null;
};

export const getRegisterTypeByDomain = (domain: DomainType): GlobalRegisterType | null => {
  const REGISTER_TYPES: Partial<Record<DomainType, GlobalRegisterType>> = {
    [DOMAINS.IN]: 'indian',
  };

  return REGISTER_TYPES[domain] || null;
};

export const getRegisterTypeByIdentity = (host: string, locale: LocaleType): GlobalRegisterType | null => {
  const domain = getSubDomain(host);

  if (isDomainHasIdentityConfig(domain)) {
    return getRegisterTypeByDomain(domain as DOMAINS);
  } else {
    return getRegisterTypeByLocale(locale);
  }
};
